import React from 'react'
import PropTypes from 'prop-types'

const Spinner = (props) => (
  <div className={`spinner${props.nomargin ? ' m-0' : ''}`}>
    <div className="double-bounce1" />
    <div className="double-bounce2" />
  </div>
)

Spinner.propTypes = {
  nomargin: PropTypes.bool,
}

export default Spinner



// WEBPACK FOOTER //
// ./client/components/Spinner.js